// extracted by mini-css-extract-plugin
export default {"documento":"DetallesRGPD_documento__27Mbz","content":"DetallesRGPD_content__Bmhs4","primary":"DetallesRGPD_primary__0XrjU"};